import { SurveyRespondentCompletedTaskModel } from '@/helpers/entities/models/SurveyRespondentCompletedTaskModel';
export class SurveyRespondentDetailsModel {
    constructor(payload) {
        this.name = payload.name;
        this.profilePic = payload.profilePic;
        const completedTask = (completion) => {
            return new SurveyRespondentCompletedTaskModel(completion.node);
        };
        this.completedTasks = payload.taskCompletions.edges.map(completedTask);
    }
}
